import { LazyQueryHookOptions, useLazyQuery } from "@apollo/client";
import meGql from "@whoppah/apollo/query/me.graphql";
import { MeQuery, MeQueryVariables } from "@whoppah/apollo/schema";

const useMeLazy = (
  options?: LazyQueryHookOptions<MeQuery, MeQueryVariables>
) => {
  return useLazyQuery(meGql, options);
};

export default useMeLazy;
